import ProductObj from "../../../OBJRep/Product";
import ProductStyles from "../../../OBJRep/ProductStyles";

//DEFAULT ENCARTE MODEL
export const DEFAULT_ENCARTE_MODEL =
  "/resources/files/location/ofertas-de-hoje.png";
export const DEFAULT_PRICE_STYLE_SERVER_LOCATION =
  "/resources/files/location/price-model-default.png/";

export const DEFAULT_PRICE_PUBLIC_LOCATION = `images/default-price.png`;
//SEARCH RESOURCES
export const PRICE_STYLE_SEARCH_KEYWORD = "price_style";
export const ENCARTE_MODEL_SEARCH_KEYWORD = "models";

//FORMATS
export const FEED_INSTAGRAM = "feed Instagram";
export const FEED_INSTAGRAM_PORTRAIT = "feed Instagram retrato";
export const STORIES = "stories";
export const PANFLETO = "panfleto";
export const PAISAGEM = "paisagem";
export const CARTAZ_PEQUENO = "cartaz pequeno";
export const CARTAZ_MEDIO = "cartaz médio";
export const CARTAZ_GRANDE = "cartaz grande";
export const CESTA_BASICA_KIT = "cesta básica ou kit";
//FORMAT TYPES
//MAX PRODUCTS FOR EACH FORMAT
export const MAX_PRODUCTS_FEED_FORMAT = 8;
export const MAX_PRODUCTS_STORIES_FORMAT = 12;
export const MAX_PRODUCTS = 16;

export const MAX_PRODUCTS_BY_FORMAT = {
  [FEED_INSTAGRAM]: 8,
  [FEED_INSTAGRAM_PORTRAIT]: 8,
  [STORIES]: 12,
  [PANFLETO]: 16,
  [CARTAZ_PEQUENO]: 8,
  [CARTAZ_MEDIO]: 4,
  [CARTAZ_GRANDE]: 1,
};
//DIMENSIONS
export const FEED_INSTAGRAM_DIM = {
  width: 1080,
  height: 1080,
  header: 380,
  footer: 60,
};

export const FEED_INSTAGRAM_PORTRAIT_DIM = {
  width: 1080,
  height: 1350,
  header: 380,
  footer: 60,
};

export const STORIES_DIM = {
  width: 1080,
  height: 1920,
  header: 600,
  footer: 236,
};

export const PANFLETO_DIM = {
  width: 1500,
  height: 2118,
  header: 530,
  footer: 220,
};

export const CESTA_BASICA_KIT_DIM = PANFLETO_DIM;
export const PAISAGEM_DIM = {
  width: 1600,
  height: 1131,
  header: 746,
  footer: 100,
};

export const CARTAZ_PEQUENO_DIM = {
  width: 530,
  height: 750,
  header: 260,
  footer: 220,
};

export const CARTAZ_MEDIO_DIM = {
  width: 1500,
  height: 2118,
  header: 530,
  footer: 220,
};

export const CARTAZ_GRANDE_DIM = {
  width: 1500,
  height: 2118,
  header: 530,
  footer: 220,
};

export const FORMAT_DIMENSIONS = {
  [FEED_INSTAGRAM]: FEED_INSTAGRAM_DIM,
  [FEED_INSTAGRAM_PORTRAIT]: FEED_INSTAGRAM_PORTRAIT_DIM,
  [STORIES]: STORIES_DIM,
  [PANFLETO]: PANFLETO_DIM,
  [PAISAGEM]: PAISAGEM_DIM,
  [CARTAZ_PEQUENO]: CARTAZ_PEQUENO_DIM,
  [CARTAZ_MEDIO]: CARTAZ_MEDIO_DIM,
  [CARTAZ_GRANDE]: CARTAZ_GRANDE_DIM,
  [CESTA_BASICA_KIT]: CESTA_BASICA_KIT_DIM,
};

//UNITY MEASUREMENT
export const UNITYS = [
  { value: "UNID", label: "Unidade" },
  { value: "KG", label: "Quilograma" },
  { value: "L", label: "Litro" },
  { value: "CX", label: "Caixa" },
  { value: "DZ", label: "Dúzia" },
  { value: "PCT", label: "Pacote" },
  { value: "FD", label: "Fardo" },
  { value: "CTL", label: "Cartela" },
  { value: "PT", label: "Pote" },
  { value: "PAR", label: "Par" },
  { value: "SCH", label: "Sachê" },
  { value: "LT", label: "Lata" },
  { value: "GAL", label: "Galão" },
  { value: "BAR", label: "Barra" },
  { value: "RL", label: "Rolo" },
  { value: "M", label: "Metro" },
  { value: "100G", label: "100 gramas" },
  { value: "200G", label: "200 gramas" },
  { value: "300G", label: "300 gramas" },
  { value: "400G", label: "400 gramas" },
  { value: "500G", label: "500 gramas" },
  { value: "600G", label: "600 gramas" },
  { value: "700G", label: "700 gramas" },
  { value: "800G", label: "800 gramas" },
  { value: "900G", label: "900 gramas" },
];

export const findUnityByLabel = (label) => {
  return UNITYS.find((u) => u.label === label);
};

export const findUnityByValue = (value) => {
  return UNITYS.find((u) => u.value === value.toUpperCase());
};

export const UNITYS_LABELS = UNITYS.map((u) => u.label);
//PRICES

//export const DEFAULT_PRICE_STYLE = "TAG";
export const ROUNDED_PRICE_STYLE = "ROUNDED";
export const ROUGHLY_ROUNDED_PRICE_STYLE = "MINIMALLY_ROUNDED";

//FONT SIZES
export const FONT_SIZES = [
  "18",
  "22",
  "26",
  "30",
  "34",
  "38",
  "40",
  "50",
  "60",
  "70",
  "80",
  "90",
  "100",
];

//LOGO SIZES

export const LOGO_SIZE_SMALL = 280;
export const LOGO_SIZE_MEDIUM = 350;
export const LOGO_SIZE_LARGE = 450;

//LOGO STYLE
export const ROUND_LOGO_WITH_BORDER = "ROUND_WITH_BORDER";
export const SQUARE_LOGO_WITH_BORDER = "SQUARE_WITH_BORDER";

//CANVAS
export const CANVAS_TARGET_CLASSNAME = "CANVAS";
export const CANVAS_WRAPPER_PRINT_TARGET_CLASSNAME = "CANVAS_WRAPPER";
export const CANVAS_VIWER_TARGET_CLASSNAME = "CANVAS_VIEWER";

//PRODUCT_LAYOUT
export const NAME_ABOVE_PRODUCT_LAYOUT = "NAME_ABOVE";
export const NAME_BENEATH_PRODUCT_LAYOUT = "NAME_BENEATH";
export const TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT = "TWO_COLUMNS_NAME_LEFT";
export const NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT =
  "NAME_AND_PRICE_SIDE_BY_SIDE";

export const PRICE_IMAGE_SIDE_PRODUCT_LAYOUT = "PRICE_IMAGE_SIDE";

export const THREE_COLUMNS_PRODUCT_LAYOUT = "THREE_COLUMNS";

// Multipliers over styles.fontSize, per layout.
export const LAYOUT_FONT_MULTIPLIERS = {
  [NAME_ABOVE_PRODUCT_LAYOUT]: { nameMultiplier: 0.9, priceMultiplier: 1 },
  [NAME_BENEATH_PRODUCT_LAYOUT]: { nameMultiplier: 0.7, priceMultiplier: 1.1 },
  [TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT]: {
    nameMultiplier: 0.7,
    priceMultiplier: 1.1,
  },
  [NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT]: {
    nameMultiplier: 0.75,
    priceMultiplier: 1,
  },
  [PRICE_IMAGE_SIDE_PRODUCT_LAYOUT]: {
    nameMultiplier: 0.8,
    priceMultiplier: 1.2,
  },
  [THREE_COLUMNS_PRODUCT_LAYOUT]: { nameMultiplier: 1, priceMultiplier: 1.4 },
};

export const getLayoutFontMultipliers = (layout) =>
  LAYOUT_FONT_MULTIPLIERS[layout] ?? { nameMultiplier: 1, priceMultiplier: 1 };
//PROMOTIONS
export const FROM_X_TO_Y_PROMOTION = "FROM_X_TO_Y";
export const TAKE_X_PAY_Y_PROMOTION = "TAKE_X_PAY_Y";
export const VAREJO_ATACADO_PROMOTION = "VAREJO_ATACADO";
export const SIMPLE_PROMOTION = "SIMPLE";

export const TXT_COLORS = [
  "#E6E6E6",
  "#f8fafc",
  "#0C0C0C",
  "#292524",
  "#696969",
  "#404040",
];
export const COLORS = [
  "#FF1744", // Vibrant Red
  "#F50057", // Vibrant Pink
  "#D500F9", // Vibrant Purple
  "#651FFF", // Vibrant Deep Purple
  "#3D5AFE", // Vibrant Indigo
  "#2979FF", // Vibrant Blue
  "#00B0FF", // Vibrant Light Blue
  "#1DE9B6", // Vibrant Teal
  "#00E676", // Vibrant Green
  "#76FF03", // Vibrant Light Green
  "#C6FF00", // Vibrant Lime
  "#FFEA00", // Vibrant Yellow
  "#FFC400", // Vibrant Amber
  "#FF9100", // Vibrant Orange
  "#FF3D00", // Vibrant Deep Orange
  "#FF6D00", // Vibrant Orange Accent
  "#FF80AB", // Vibrant Pink Accent
  "#EA80FC", // Vibrant Purple Accent
  "#B388FF", // Vibrant Violet Accent
  "#8C9EFF", // Vibrant Blue Accent
  "#f8fafc",
  "#0C0C0C",
  "#FFAB00",
  "#FF4081",
  "#69F0AE",
  "#00E5FF",
  "#EEFF41",
  "#7C4DFF",
  "#FF6E40",
  "#B2FF59",
  "#991b1b",
  "#f59e0b",
  "#3730a3",
];

export const ENCARTE_FORMATS = [FEED_INSTAGRAM, STORIES];

/**********************PRODUCT EXAMPLES***********************/

//REUSABLE STYLES
const PRODUCT_STYLES = ProductStyles();
PRODUCT_STYLES.fontSize = "72";

export const PRODUCT_WITH_FROM_X_TO_Y_PROMOTION = ProductObj(
  0,
  "Coca Cola",
  "7,99",
  "",
  "",
  UNITYS[0],
  PRODUCT_STYLES,
  FROM_X_TO_Y_PROMOTION,
  undefined,
  undefined,
  "9,99",
);
